module.exports = __webpack_public_path__ + "static/media/dont1.0a92b3c6.png";